var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOxe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_OXE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 39.375,
    height: 13.267,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_OXE-2",
    "data-name": "icon_OXE",
    transform: "translate(1.313 14.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3781",
    "data-name": "Groupe 3781",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13580",
    "data-name": "Trac\\xE9 13580",
    d: "M37.358,0H2.02A2.123,2.123,0,0,0,0,2.211v8.842a2.124,2.124,0,0,0,2.02,2.214H37.358a2.122,2.122,0,0,0,2.017-2.214V2.211A2.121,2.121,0,0,0,37.358,0M6.444,9.486a.859.859,0,0,1-.859.859h-1.4a.859.859,0,0,1-.859-.859v-1.4a.859.859,0,0,1,.859-.859h1.4a.859.859,0,0,1,.859.859Zm0-4.3a.859.859,0,0,1-.859.859h-1.4a.859.859,0,0,1-.859-.859V3.778a.857.857,0,0,1,.859-.856h1.4a.857.857,0,0,1,.859.856Zm4.809,4.3a.857.857,0,0,1-.859.859H8.99a.859.859,0,0,1-.859-.859v-1.4a.859.859,0,0,1,.859-.859h1.4a.857.857,0,0,1,.859.859Zm0-4.3a.857.857,0,0,1-.859.859H8.99a.859.859,0,0,1-.859-.859V3.778a.857.857,0,0,1,.859-.856h1.4a.855.855,0,0,1,.859.856Zm4.812,4.3a.859.859,0,0,1-.859.859H13.8a.857.857,0,0,1-.856-.859v-1.4a.857.857,0,0,1,.856-.859h1.407a.859.859,0,0,1,.859.859Zm0-4.3a.859.859,0,0,1-.859.859H13.8a.857.857,0,0,1-.856-.859V3.778a.854.854,0,0,1,.856-.856h1.407a.857.857,0,0,1,.859.856Zm4.809,4.3a.859.859,0,0,1-.859.859h-1.4a.859.859,0,0,1-.859-.859v-1.4a.859.859,0,0,1,.859-.859h1.4a.859.859,0,0,1,.859.859Zm0-4.3a.859.859,0,0,1-.859.859h-1.4a.859.859,0,0,1-.859-.859V3.778a.857.857,0,0,1,.859-.856h1.4a.857.857,0,0,1,.859.856Zm7.325,5.16H27.035a.873.873,0,1,1,0-1.746H28.2a.873.873,0,0,1,0,1.746m3.491,0H30.526a.873.873,0,1,1,0-1.746H31.69a.873.873,0,0,1,0,1.746m3.491,0H34.018a.873.873,0,1,1,0-1.746h1.164a.873.873,0,0,1,0,1.746",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOxe);
export default __webpack_public_path__ + "static/media/icon_OXE.5d0026c8c2b6b7c30ff545931dad4eea.svg";
export { ForwardRef as ReactComponent };